export const FONTS = {
  general_sans: {
    label: "General Sans",
    stack: "'General Sans', 'Segoe UI', Arial, sans-serif",
    category: "Editorial",
  },
  satoshi: {
    label: "Satoshi",
    stack: "'Satoshi', 'Segoe UI', Arial, sans-serif",
    category: "Modern",
  },
  manrope: {
    label: "Manrope",
    stack: "'Manrope', 'Segoe UI', Arial, sans-serif",
    category: "Geometric",
  },
  ibm_plex: {
    label: "IBM Plex Sans",
    stack: "'IBM Plex Sans', 'Segoe UI', Arial, sans-serif",
    category: "Technical",
  },
  dm_sans: {
    label: "DM Sans",
    stack: "'DM Sans', 'Segoe UI', Arial, sans-serif",
    category: "Neutral",
  },
  work_sans: {
    label: "Work Sans",
    stack: "'Work Sans', 'Segoe UI', Arial, sans-serif",
    category: "Industrial",
  },
  playfair: {
    label: "Playfair Display",
    stack: "'Playfair Display', 'Times New Roman', Georgia, serif",
    category: "Serif Editorial",
  },
  bebas_neue: {
    label: "Bebas Neue",
    stack: "'Bebas Neue', 'Impact', 'Arial Narrow', sans-serif",
    category: "Display",
  },
  archivo_black: {
    label: "Archivo Black",
    stack: "'Archivo Black', 'Helvetica Neue', Arial, sans-serif",
    category: "Heavy Display",
  },
  fraunces: {
    label: "Fraunces",
    stack: "'Fraunces', 'Times New Roman', Georgia, serif",
    category: "Soft Serif",
  },
  space_grotesk: {
    label: "Space Grotesk",
    stack: "'Space Grotesk', 'Segoe UI', Arial, sans-serif",
    category: "Tech Modern",
  },
  inter_tight: {
    label: "Inter Tight",
    stack: "'Inter Tight', 'Segoe UI', Arial, sans-serif",
    category: "Compact UI",
  },
};

export const fontStack = (key) => (FONTS[key] || FONTS.general_sans).stack;
